<template>
  <div class="bids-add-bulk-pricing-table-action-column">
    <DeleteWithConfirm :delete-function="deleteItem" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { BULK_IMPORT_DELETE_BID } from '@/store/types';

import DeleteWithConfirm from '@@/common/action-buttons/DeleteWithConfirm';

export default {
  name: 'BidsAddBulkPricingTableActionColumn',
  components: {
    DeleteWithConfirm,
  },
  props: {
    row: {
      required: true,
      type: Object,
    },
  },
  methods: {
    ...mapActions({ deleteBidFromStore: BULK_IMPORT_DELETE_BID }),
    deleteItem() {
      return Promise.resolve(this.deleteBidFromStore(this.row));
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-pricing-table-action-column {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
